module.exports = __webpack_public_path__ + "static/img/noPermission.9409417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noPermission.png
// module id = Ap7C
// module chunks = 1